import React, {
    useState,
    useEffect,
    useRef,
    createContext,
    useContext,
} from "react";

import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";

const GlobalAppContext = createContext();

const Audit = ({ submissionId, users }) => {

    const [auditRecord, setAuditRecord] = useState([]);
    const [isLoadingObjects, setIsLoadingObjects] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMoreActions, setHasMoreActions] = useState(true);
    /*
    Convert: Wed Aug 30 2023 00:00:00 GMT+0100 (Western European Summer Time) 
    To: 2023-08-30
    */

    const formatDate = (dateStr, includeTime = false) => {
        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
        const day = String(dateObj.getDate()).padStart(2, "0");

        let time = "";
        if (includeTime) {
            let hours = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
            let minutes = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();

            time = ` ${hours}:${minutes}`;
        }

        const formattedDate = `${year}-${month}-${day}${time}`;
        return formattedDate;
    };


    useEffect(() => {

        loadObjects();

    }, []);


    const loadObjects = ({ nextPage = false } = {}) => {

        if (isLoadingObjects) return;

        if (!hasMoreActions) return;

        setIsLoadingObjects(true);

        let local_objects_page = page;

        if (nextPage == false) {
            local_objects_page = 1;
            setPage(local_objects_page);
            setHasMoreActions(true);
        } else {
            local_objects_page++;
            setPage(local_objects_page);
        }

        let loadObjectsURL =
            `/umbraco/api/Submission/Actions?` +
            `submissionId=${submissionId}&` +
            `page=${local_objects_page}&`;

        let requestOptions = {};

        fetch(loadObjectsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreActions(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data.length > 0)
                    setAuditRecord(prev => [...prev, ...data]);
                else {
                    setHasMoreActions(false);
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoadingObjects(false);
            });
    };


    const findUsername = (memberId) => {

        let user = users.find(member => member.Id == memberId);

        if (user)
            return user.Name;

        return "";

    }

    
    /* SCROLLING BEHAVIOUR */

    const ref = useRef();
    const isVisible = useIsVisible(ref);

    function useIsVisible(ref) {
        const [isIntersecting, setIntersecting] = useState(false);

        useEffect(() => {
            const observer = new IntersectionObserver(([entry]) =>
                setIntersecting(entry.isIntersecting),
            );

            observer.observe(ref.current);
            return () => {
                observer.disconnect();
            };
        }, [ref]);

        //console.log("isVisible? ", isIntersecting);

        return isIntersecting;
    }


    useEffect(() => {

        if (isVisible && hasMoreActions && !isLoadingObjects) {
            loadObjects({ nextPage: true });
        }
    }, [isVisible, isLoadingObjects]);

    



    return (<>


        {/* Audit list */}

        {auditRecord.length > 0 && <>
            {auditRecord.map((audit) => {
                    let action = audit.Action;
                    let memberName = findUsername(audit.MemberId);
                    let actionDate = audit.ActionDate;
                return <div>{formatDate(actionDate, true)} - <b>{memberName}</b> - {action}</div>
                }
            )}
        </>}

        {isLoadingObjects ? <>
            <div>
                <LoadingSpinnerImage />
            </div>
        </> : <>

            {!hasMoreActions && (
                <div className="no-more-results">{auditRecord.length > 0 ? "No more actions" : "No actions"}</div>
            )}


        </>}

        <div ref={ref}></div>

        

        <div style={{ minHeight: "20px" }}></div>

    </>);

};



export default Audit;